import * as types from './mutation-types';

export const userLogin = ({ dispatch }, info) => {
  dispatch(types.USER_LOGIN, info);
  dispatch(types.SOCKET_REGISTER, info.userid, info.session);
};

export const userLogout = ({ dispatch }) => {
  dispatch(types.USER_LOGOUT);
};

export const userFetch = ({ dispatch }) => {
  dispatch(types.USER_FETCH);
};

export const userUpdate = ({ dispatch }) => {
  dispatch(types.USER_UPDATE);
};

export const userUpdateInfo = ({ dispatch }, info) => {
  dispatch(types.USER_INFO, info);
};

export const socketRegister = ({ dispatch }, userid, session) => {
  dispatch(types.SOCKET_REGISTER, userid, session);
};

export const sendMessage = ({ dispatch }, to, content) => {
  dispatch(types.SOCKET_SEND, to, content);
};

export const getRecentContactList = ({ dispatch }) => {
  dispatch(types.MESSAGE_RECENT_CONTACT);
};

export const fetchMessage = ({ dispatch }, userid) => {
  dispatch(types.MESSAGE_FETCH, userid);
};

export const setSchool = ({ dispatch }, school) => {
  dispatch(types.SCHOOL_SET, school);
};

export const setSchoolList = ({ dispatch }, schoolList) => {
  dispatch(types.SCHOOL_LIST, schoolList);
};

export const setStyleWide = ({ dispatch }, wide) => {
  dispatch(types.STYLE_WIDE_SET, wide);
};

export const setTypes = ({ dispatch }, _types) => {
  dispatch(types.TYPES_SET, _types);
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js